<template>
  <div
    ref="navItem"
    class="right-nav__button"
    :class="[activeClass]"
    name="right_nav_button"
    v-aha-emit-action="{ user_input: navItemName}"
    @click.stop="onNavItemClicked()"
  >
    <aha-icon
      :name="navItemIconName"
      :width="navItemIconWidth"
      :height="navItemIconHeight"
      :viewBox="navItemIconViewBox"
      class="right-nav__button-icon"
    ></aha-icon>
    <p class="right-nav__button-label" :lang="getPresenterLocale">
      {{ $i18nPresenter.t(navItemName) }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    activeType: {
      type: String,
      default: null,
    },
    navItem: {
      type: Object,
      default: () => ({
        name: '',
        icon: {},
      }),
    },
  },

  computed: {
    ...mapGetters(['selectedSlides', 'getPresenterLocale']),

    activeClass() {
      return this.activeType ? `active-${this.activeType}` : ''
    },

    navItemName() {
      return this.navItem && this.navItem.name
    },

    hasNavItemIcon() {
      return this.navItem && this.navItem.icon
    },

    navItemIconName() {
      return this.hasNavItemIcon && this.navItem.icon.name
    },

    navItemIconWidth() {
      return this.hasNavItemIcon && this.navItem.icon.width
    },

    navItemIconHeight() {
      return this.hasNavItemIcon && this.navItem.icon.height
    },

    navItemIconViewBox() {
      return this.hasNavItemIcon && this.navItem.icon.viewBox
    },
  },

  methods: {
    onNavItemClicked() {
      this.$emit('onNavItemClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.right-nav__button {
  @apply bg-base-0;
  @apply rounded-lg;
  @apply font-bold text-center p-2 mt-0 mx-1 mb-2 cursor-pointer;
  width: 88px;
  height: 64px;
  transition: all 0.1s ease-in-out;
  &:hover:not(.disabled) {
    @apply hover:bg-secondary-15;
    &.active-primary {
      @apply bg-primary-100;
    }
  }
  &.active-primary:not(.disabled) {
    @apply bg-primary-90 text-base-0;
    .right-nav__button-icon {
      @apply text-base-0;
    }
  }
  &.active-purple {
    background: url(~@/assets/images/ai-generator/rightNav-AI-button-background.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @apply bg-base-0 text-base-0;
    .right-nav__button-icon {
      @apply text-base-0;
    }
  }
  &.disabled {
    @apply cursor-not-allowed;
  }
}
.right-nav__button-icon {
  @apply mb-1 text-secondary-100;
}
.right-nav__button-label {
  @apply w-full break-words;
  hyphens: auto;
  word-break: break-word;
}
</style>
